import LlmPromptProfilesPanel from './LlmPromptProfilesPanel'
import LlmRoutingAdminPanel from './LlmRoutingAdminPanel'

export default function LlmRoutingPromptAdmin({ engines }) {
  return <div className="space-y-6"><LlmRoutingAdminPanel engines={engines} /><LlmPromptProfilesPanel engines={engines} /></div>
}
